import { Box, Button, Flex, H2, Modal, Text } from '@bfa/common-ui';
import React, { useEffect } from 'react';

import { Divider } from '../../../../components/Divider';
import { Maybe, Scalars } from '../../../../gql.generated';
import { GBX_ANALYTICS_LABELS } from '../../constants';
import BulletedList from '../BulletedList';

const LearnMoreModal = ({
  showModal,
  toggleModal,
  logAnalytics,
  header,
  explanatory,
  explanatoryExtra,
  bulletPoints,
  shouldSeelearnMoreModal,
}: {
  showModal: boolean;
  toggleModal: () => any;
  logAnalytics: (label: string) => any;
  header?: Maybe<Scalars['String']['output']>;
  explanatory?: Maybe<Scalars['String']['output']>;
  explanatoryExtra?: Maybe<Scalars['String']['output']>;
  bulletPoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shouldSeelearnMoreModal: boolean;
}) => {
  useEffect(() => {
    if (shouldSeelearnMoreModal && showModal) {
      logAnalytics(GBX_ANALYTICS_LABELS.VIEWED_LEARN_MORE);
    }
  }, [logAnalytics, shouldSeelearnMoreModal, showModal]);
  if (!shouldSeelearnMoreModal) return null;
  return (
    <Modal isOpen={showModal} showDismiss={false} margin="2rem">
      <Flex flexDirection="column" alignItems="center">
        <H2>{header}</H2>
        {explanatory && (
          <Text margin="1.5rem" textAlign="center">
            {explanatory}
          </Text>
        )}
        {explanatoryExtra && (
          <Text margin="1.5rem" textAlign="center">
            {explanatoryExtra}
          </Text>
        )}
        <Box margin={['0 1rem', '0 2rem']}>
          <BulletedList bulletsPoints={bulletPoints} />
        </Box>
      </Flex>
      <Divider small marginTop="2rem" />
      <Box textAlign="center">
        <Button
          main
          fullWidth
          link
          onClick={toggleModal}
          margin={['2rem 0', '2.4rem 0']}
        >
          OKAY
        </Button>
      </Box>
    </Modal>
  );
};

export default LearnMoreModal;
